import { clsx } from 'clsx';

import styles from './Loader.module.scss';

const Loader = ({ className, ...props }: React.HTMLProps<HTMLDivElement>) => {
  return <div className={clsx(styles.loader, className)} role="status" {...props} />;
};

export default Loader;
